import React from "react";
export const ScreenVisibilityContext = React.createContext(false);
